import React, { FC, MutableRefObject } from 'react';
import classNames from 'classnames';
import { makeStyles } from 'tss-react/mui';

import { transactionsTypes } from 'companion-app-components/flux/transactions';

import { isC2RTransaction } from 'data/transactions/utils';
import AmountField, { ShowSignEnum, ShowColorEnum } from 'components/QuickenControls/AmountField/index';

import { RegListItem, styles } from '../styles';

import type { AttributesType, CallbacksType } from '../types';

const useStyles = makeStyles()(styles as Record<string, any>);

interface TxnRowAmountFieldProps {
  attributes: AttributesType;
  callbacks: CallbacksType;
  editable: boolean;
  SHOW_ALL: boolean;
  txn: transactionsTypes.CashFlowTransaction;
  editClass: string; 
  hoverClass: string; 
  bankPendingClass: string;
  field: string;
  fieldIsEditable: (field: string) => boolean;
  currEditFieldName: string;
  currencySymbol: string;
  enableAutoFocus: boolean;
  amountProposedSign: number | null;
  focusField: MutableRefObject<HTMLAnchorElement | null>;
}

const TxnRowAmountField: FC<TxnRowAmountFieldProps> = ({
  attributes,
  callbacks,
  editable,
  SHOW_ALL,
  txn,
  editClass, 
  hoverClass, 
  bankPendingClass,
  field,
  fieldIsEditable,
  currEditFieldName,
  currencySymbol,
  enableAutoFocus,
  amountProposedSign,
  focusField,
}) => {
  const { classes, theme } = useStyles();
  const c2RTxnClass = isC2RTransaction(txn) ? classes.txnInC2RText : '';
  return (
    <RegListItem
      {...attributes}
      className={classNames('amount', classes.regItem, 'protectWidth', editClass, hoverClass, bankPendingClass, c2RTxnClass)}
    >
      {SHOW_ALL &&
      <AmountField
        // @ts-expect-error: Property 'register' does not exist on type 'Components<BaseTheme>'.
        disableUnderline={theme.components?.register.noUnderline}
        clickable={fieldIsEditable(field) ? 'true' : null}
        thinFont
        // @ts-expect-error: Property 'register' does not exist on type 'Components<BaseTheme>'.
        fontSize={theme.components?.register.fontSize.default}
        amountType="amount"
        proposedSign={amountProposedSign ?? undefined}
        lockInitialProposedSign
        onChange={callbacks.handleChange}
        onBlur={(e, fieldType, wasEnter) => {
          callbacks.onAmountBlur?.(e, field, wasEnter);
        }}
        editable={fieldIsEditable(field) && editable && currEditFieldName === 'amount'}
        autoFocus={enableAutoFocus}
        // @ts-expect-error: Type 'string' is not assignable to type 'number'.
        value={String(txn.amount)}
        className={classNames(classes.regInput, 'amount')}
        currencySymbol={currencySymbol}
        // @ts-expect-error: null is not assignable to type
        inputRef={fieldIsEditable(field) && editable && currEditFieldName === 'amount' ?
          (input) => {
            // @ts-expect-error: inputRef provides HTMLInputElement but focusField is typed as HTMLAnchorElement
            focusField.current = input; // eslint-disable-line
          } : null}
        showSign={ShowSignEnum.NEGATIVE_ONLY}
        showColor={ShowColorEnum.POSITIVE_ONLY}
      >
      </AmountField>}
    </RegListItem>
  );
};

export default TxnRowAmountField;
